import { Coordinates } from '@/vehicle/models/Location';
import Country from './Country';
import { DmsConnection, Url } from './common';

export interface OutletId { __outletId: number}

export default class Outlet {
  id!: OutletId;
  description!: string;
  avatar: Url | null = null;
  address: string | null = null;
  secondAddress: string | null = null;
  zipCode: string | null = null;
  vatNumber: string | null = null;
  city: string | null = null;
  companyId: number | null = null;
  isMainOutlet = false;
  linked = false;
  country: Country | null = null;
  abbreviation: string | null = null;
  hasWorkshopPlanning = false;
  hasWorkshopPlanningLight = false;
  hasWorkshopDossiersLicence = false;
  hasWorkshopBookingsLicence = false;
  hasWorkshopPlanningLicence = false;
  hasPickingStatus = false;
  hasWarrantyLicence = false;
  hasTimeRegistration = false;
  requiresCheckInLocation = false;
  requiresSignature = false;
  location: Coordinates | null = null;
  hasSurveyLicence = false;
  hasDBBLicence = false;
  canStartMultipleJobs = false;
  hasAutomaticTimeRegistration = false;
  dmsConnections: Array<DmsConnection> = [];
  hasContinuousTimeRegistration = false;
  hasCleaningMethodSelection = false;
  hasInteriorCleaning = false;
  hasMandatoryCleaningDecision = false;

  get initials(): string {
    return this.description?.split(' ').map(word => word[0].toUpperCase()).join('') ?? '';
  }

  static withData(data: Partial<Outlet>): Outlet {
    return Object.assign(new Outlet(), data);
  }
}
